import React from 'react';
import {
  Modal,
} from '@routific/hive';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store/mst';
import ZIndex from '../../shared/CSS/ZIndex';
import ScheduleWarningFooter from './molecules/ScheduleWarningFooter';
import SchedulingWarningModalContent from './organisims/SchedulingWarningModalContent';

interface Props {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
  invalidStopsCount: number,
  questionableStopsCount: number,
  isPublish?: boolean
  onToggle?: () => void;
  showCancel?: boolean;
}

const ScheduleWarningModal: React.FC<Props> = ({
  visible,
  onOk,
  onCancel,
  isPublish,
  onToggle,
  invalidStopsCount,
  questionableStopsCount,
  showCancel = true,
}) => {

  const { t } = useTranslation('components');
  const { ui: { isOptimizing } } = useStore();

  const handleToggle = () => {
    onToggle?.();
    onCancel();
  };

  return (
    <Modal
      size="small"
      centered
      visible={visible}
      zIndex={ZIndex.MAX}
      maskClosable={false} //TODO: set this as the default in hive as this is the standard UX direction.
      title={t('unscheduledVisits.scheduleWarningModal.title')}
      data-cy="schedule-warning-confirm-modal"
      onCancel={onCancel}
      footer={
        <ScheduleWarningFooter
          onOk={onOk}
          onCancel={onCancel}
          onToggle={handleToggle}
          isOptimizing={isOptimizing ?? false}
          showCancel={showCancel}
          isPublished={isPublish ?? false}
        />
      }
    >
      <SchedulingWarningModalContent
        invalidStopsCount={invalidStopsCount}
        questionableStopsCount={questionableStopsCount}
      />
    </Modal>
  );
};

export default observer(ScheduleWarningModal);
